
import { useTranslation } from "react-i18next";
import { BrainCog, Cpu, Gauge, Shield } from "lucide-react";

const ResponsibleAI = () => {
  const { t } = useTranslation(["responsibleAI"]);

  const features = [
    {
      title: t('features.database.title'),
      description: t('features.database.description'),
      icon: <Cpu className="w-12 h-12 text-brand-orange dark:text-brand-orange" />
    },
    {
      title: t('features.ai.title'),
      description: t('features.ai.description'),
      icon: <BrainCog className="w-12 h-12 text-[#8B5CF6]" />
    },
    {
      title: t('features.math.title'),
      description: t('features.math.description'),
      icon: <Gauge className="w-12 h-12 text-brand-orange dark:text-brand-orange" />
    },
    {
      title: t('features.ethical.title'),
      description: t('features.ethical.description'),
      icon: <Shield className="w-12 h-12 text-[#8B5CF6]" />
    }
  ];

  return (
    <section className="section bg-background py-24">
      <div className="container-custom">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-4xl sm:text-5xl font-bold text-center mb-8 bg-clip-text text-transparent bg-gradient-to-r from-brand-blue to-brand-orange leading-[2.6] pb-4">
            {t('title')}
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed text-center mb-16 max-w-3xl mx-auto">
            {t('description')}
          </p>
          <div className="grid gap-8 md:grid-cols-2">
            {features.map((feature, index) => (
              <div 
                key={index}
                className="group bg-card rounded-2xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-border"
              >
                <div className="flex flex-col items-center text-center mb-6">
                  <div className="p-4 bg-background rounded-2xl mb-6 shadow-md group-hover:scale-110 transition-transform border border-border">
                    {feature.icon}
                  </div>
                  <h3 className="text-2xl font-medium text-brand-blue dark:text-brand-orange transition-colors mb-4">
                    {feature.title}
                  </h3>
                  <p className="text-muted-foreground leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResponsibleAI;
